import classnames from 'classnames';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { VSpacing, useBreakpoint, Text } from '@hh.ru/magritte-ui';
import { HhProBrandSize24, HhProBrandSize32 } from '@hh.ru/magritte-ui/service';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { SubscriptionAction } from 'src/hooks/hhPro/usePayment';
import useSubscribeAction from 'src/hooks/hhPro/useSubscribeAction';
import useActiveSubscription from 'src/hooks/useActiveSubscription';
import SubscribeControl from 'src/pages/HhProPromo/components/SubscribeControl';
import Oferta from 'src/pages/HhProPromo/components/SubscribeControl/Oferta';
import { FormState } from 'src/types/HhProFormState';
import { NON_BREAKING_SPACE as NBSP } from 'src/utils/symbols';

import styles from './styles.less';

const TrlKeys = {
    title: 'hhpro.promo.resumeTargetEmployer.title',
    titlePrep: 'hhpro.promo.resumeTargetEmployer.title.preposition',
    subtitle: 'hhpro.promo.resumeTargetEmployer.subtitle',
};

const HeaderResumeTargetEmployer: TranslatedComponent<{
    formState: FormState;
    initPayment: () => void;
    initCancel: () => void;
    initRenew: () => void;
    setFormState: (formState: FormState) => void;
}> = ({ trls, ...formParams }) => {
    const hhpro = useSelectorNonNullable((store) => store.hhPro);
    const activeSubscription = useActiveSubscription();
    const action = useSubscribeAction(activeSubscription);
    const breakpoint = useBreakpoint();

    return (
        <div className={classnames(styles.top, styles.topLarge)}>
            <div className={styles.topContent}>
                <div>
                    <VSpacing default={16} gteM={56} />
                    <h1 className={styles.titleInline}>
                        {trls[TrlKeys.title]}{' '}
                        <div className={styles.labelContainer}>
                            {trls[TrlKeys.titlePrep]}
                            {NBSP}
                            <div className={classnames(styles.labelWrapper, styles.labelWrapperInline)}>
                                <div className={classnames(styles.label, styles.labelBold)}>
                                    {breakpoint.isMobile ? <HhProBrandSize24 /> : <HhProBrandSize32 />}
                                    PRO
                                </div>
                            </div>
                        </div>
                    </h1>

                    <VSpacing default={12} gteM={20} />
                    <div className={styles.subtitle}>
                        <Text
                            typography={breakpoint.isMobile ? 'paragraph-3-regular' : 'paragraph-1-regular'}
                            style="contrast"
                        >
                            {trls[TrlKeys.subtitle]}
                        </Text>
                    </div>
                    <VSpacing default={16} gteM={0} />
                </div>
                <div>
                    {[SubscriptionAction.Payment, SubscriptionAction.Renew].includes(action) && (
                        <>
                            <VSpacing default={0} gteM={40} />
                            <div className={styles.bottom}>
                                <SubscribeControl
                                    currency={hhpro.currency}
                                    price={hhpro.price}
                                    tariffId={hhpro.id}
                                    subscription={activeSubscription}
                                    label="desktop-header"
                                    {...formParams}
                                />
                                <Oferta />
                            </div>
                        </>
                    )}
                    <VSpacing default={8} gteM={56} />
                </div>
            </div>
            <div className={styles.imageWrapper}>
                <div className={styles.imageLarge}></div>
            </div>
        </div>
    );
};

export default translation(HeaderResumeTargetEmployer);
